import React, { useState, useEffect, useContext } from 'react';
import { CategoryInsightsSettingsContext } from '.';
import {
	getCategoryInsightSettings,
	getDropdownCategoryVendors,
	getInsightCardsSettings,
	updateInsightCardsSettings,
} from 'utils/apiRequests';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import {
	getRequiredCustomFilterObjectFormat,
	InsightsType,
} from 'CategoryManagement/utils';

const initialState = {
	loading: true,
	dashBoardSettings: null,
	fragmentation: null,
	vendorCountMax: null,
	wellmanaged: null,
	vendorCountMin: null,
	paymentTerms: null,
	pCardCategories: null,
	option: [],
	selectedOption: [],
	isSaving: false,
};
export const chartsOptionInitial = [
	{
		key: 0,
		settingsKey: 'TotalSpendBySubCategory',
		name: 'Spend By Sub Category',
		title: 'Total Spend By Sub-category',
		show: true,
	},
	{
		key: 1,
		settingsKey: 'Top10VendorsBySpend',

		name: 'Top 10 Vendor',
		title: 'Top 10 Vendors By Spend',
		show: true,
	},
	{
		key: 2,
		settingsKey: 'TotalSpendByCountry',

		name: 'Spend By Country ',
		title: 'Total Spend By Country',
		show: false,
	},
	{
		key: 3,
		settingsKey: 'AverageVendorSpendByCategory',

		name: 'Avg Vendor Spend By Category',
		title: 'Average Vendor Spend By Category',
		show: true,
	},
	{
		key: 4,
		settingsKey: 'VendorPareto',

		name: 'Pareto',
		title: 'Vendor Pareto',
		show: true,
	},
	{
		key: 5,
		settingsKey: 'SupplierLandscape',

		name: 'Supplier Landscape',
		title: 'Supplier Landscape',
		show: true,
	},
	{
		key: 6,
		settingsKey: 'TotalSpendByBusinessUnit',

		name: 'Business Unit',
		title: 'Total Spend By Business Unit',
		show: true,
	},
	{
		key: 7,
		settingsKey: 'TotalSpendByCostCenter',

		name: 'Cost Center',
		title: 'Total Spend By Cost Center',
		show: false,
	},
	{
		key: 8,
		settingsKey: 'DaysPaidOutstanding',

		name: 'DPO',
		title: 'Days Paid Outstanding',
		show: false,
	},
	{
		key: 9,
		settingsKey: 'SpendGrowthOverTime',

		name: 'Spend Over Time',
		title: 'Spend Growth Over Time',
		show: true,
	},
	{
		key: 10,
		settingsKey: 'CustomChartTwo',
		name: 'Custom Chart',
		title: 'Spend By Custom Filters',
		show: false,
	},
	{
		key: 11,
		settingsKey: 'PaymentTermsSupplier',
		name: 'Payment Terms By Top Suppliers',
		title: 'Payment Terms By Top Suppliers',
		show: true,
	},
	{
		key: 12,
		settingsKey: 'ContractCoveragePercent',
		name: 'Contract Coverage By Category',
		title: 'Contract Coverage By Category',
		show: true,
	},
	{
		key: 13,
		settingsKey: 'SupplierSegmentationCalssification',
		name: 'Supplier Segmentation classification',
		title: 'Supplier Segmentation Classification',
		show: true,
	},

	{
		key: 14,
		settingsKey: 'SpendbyYear',
		name: 'Spend by Year',
		title: 'YoY Spend Comparison',
		show: true,
	},
	{
		key: 15,
		settingsKey: 'CommonsuppliersbyBU',
		name: 'Common Suppliers by BU',
		title: 'Common Suppliers by BU',
		show: true,
	},
	{
		key: 16,
		settingsKey: 'SpendbyMonth',
		name: 'Spend by Month',
		title: 'MoM Spend Comparison',
		show: true,
	},
];
const updateIsSelectedFlag = (data, idToUpdate, flag) => {
	return data.map(item => {
		if (item.id === idToUpdate) {
			item.isSelected = !flag;
		} else {
			item.isSelected = false;
		}
		return item;
	});
};

const initialCardTypeConfig = InsightsType.map(el => {
	return {
		...el,
		isSelected: false,
	};
});

const getCartTypeDataToActive = data => {
	const filteredData = data.filter(el => el.isVisible === true);
	const type = [...new Set(filteredData.map(el => el.cardType))];
	if (type.length === 1) {
		return type.toString();
	} else {
		if (filteredData.length === 13) {
			return InsightsType[0].value;
			// return 'all insights';
		} else {
			return '';
		}
	}
};

const CategoryInsightsSettingsContextProvider = ({ children }) => {
	const [state, setState] = useState(initialState);
	const [cardsSettings, setCardsSettings] = useState([]);
	const [isCardsSettingsSaving, setIsCardsSettingsSaving] = useState(false);
	const [cardTypes, setCardTypes] = useState(initialCardTypeConfig);
	const {
		currentSelectCategory,
		isSourceable,
		isDirect,
		taxonomyType,
		customFilters,
		customFiltersValues,
	} = useContext(CategoryManagementContext);
	const { categoryName } = currentSelectCategory;

	const fetchData = async () => {
		const payload = {
			categoryName: categoryName,
			isSourceable: isSourceable,
			aptaxonomy: isDirect,
			taxonomyType: taxonomyType,
		};
		if (Array.isArray(customFiltersValues) && customFiltersValues.length > 0) {
			payload.customfilter = getRequiredCustomFilterObjectFormat(
				customFilters,
				customFiltersValues
			);
		}
		return Promise.all([
			getCategoryInsightSettings(),
			getDropdownCategoryVendors(payload),
			getInsightCardsSettings(),
		]).then(([insightResponse, dropdownResponse, cardSettingsResponse]) => {
			const settings = Object.entries(
				JSON.parse(insightResponse.data[1].value)
			).map(([name, isVisible]) => ({ name, isVisible }));
			const mergedSettings = chartsOptionInitial.map(chart => {
				const correspondingObject = settings.find(
					obj => obj.name === chart.settingsKey
				);
				return {
					...chart,
					show: correspondingObject
						? correspondingObject.isVisible
						: chart.show,
				};
			});
			setState({
				...state,
				dashBoardSettings: mergedSettings,
				fragmentation: JSON.parse(insightResponse.data[0].value)
					.fragmentedCategories.threshold,
				vendorCountMax: JSON.parse(insightResponse.data[0].value)
					.fragmentedCategories.vendorCountMax,
				wellmanaged: JSON.parse(insightResponse.data[0].value)
					.wellManagedCategories.threshold,
				vendorCountMin: JSON.parse(insightResponse.data[0].value)
					.wellManagedCategories.vendorCountMin,
				paymentTerms: JSON.parse(insightResponse.data[0].value).PaymentTerms
					.threshold,
				pCardCategories: JSON.parse(insightResponse.data[0].value)
					.pCardCategories.threshold,
				selectedOption: JSON.parse(insightResponse.data[0].value)
					.outOfPolicySpend.vendorName,
				option:
					dropdownResponse?.data?.sort((a, b) =>
						a.label.localeCompare(b.label)
					) || [],
				loading: false,
			});
			if (cardSettingsResponse.succeeded) {
				if (cardSettingsResponse.data.length > 0) {
					setCardsSettings(cardSettingsResponse.data);
				}
			}
		});
	};

	useEffect(
		() => {
			fetchData();
		}, // eslint-disable-next-line
		[
			currentSelectCategory,
			isSourceable,
			isDirect,
			taxonomyType,
			customFilters,
			customFiltersValues,
		]
	);

	useEffect(
		() => {
			if (cardsSettings.length > 0) {
				updateCardTypeData();
			}
		}, // eslint-disable-next-line
		[cardsSettings]
	);

	const updateCardTypeData = () => {
		const type = getCartTypeDataToActive(cardsSettings);
		let cardTypeData = [];
		if (type === '') {
			cardTypeData = cardTypes.map(el => {
				return { ...el, isSelected: false };
			});
		} else {
			cardTypeData = cardTypes.map(el => {
				if (el.value === type) {
					return { ...el, isSelected: true };
				} else {
					return el;
				}
			});
		}
		setCardTypes(cardTypeData);
	};

	const updateValue = (field, newValue) => {
		if (field === 'selectedOption') {
			setState({ ...state, selectedOption: newValue });
		} else {
			setState({ ...state, [field]: newValue });
		}
	};

	const handleSaveSettings = value => {
		setState(prevState => ({
			...prevState,
			isSaving: value,
		}));
	};

	const handleSaveCardSettings = () => {
		if (cardsSettings.length > 0) {
			setIsCardsSettingsSaving(true);
			updateInsightCardsSettings(cardsSettings)
				.then(() => {
					setIsCardsSettingsSaving(false);
				})
				.catch(() => {
					setIsCardsSettingsSaving(false);
				});
		}
	};

	const handleToggleCard = index => {
		setCardsSettings(prevItems => {
			const updatedItems = [...prevItems];
			updatedItems[index - 1] = {
				...updatedItems[index - 1],
				isVisible: !updatedItems[index - 1].isVisible,
			};
			return updatedItems;
		});
	};

	const handleCardTypeFilter = (id, value, flag) => {
		const filteredCards = cardsSettings.map(item => {
			if (value === InsightsType[0].value) {
				return { ...item, isVisible: true };
			} else {
				if (item.cardType === value) {
					return { ...item, isVisible: true };
				} else {
					return { ...item, isVisible: false };
				}
			}
		});
		setCardsSettings(filteredCards);

		const updateFlag = updateIsSelectedFlag(cardTypes, id, flag);
		setCardTypes(updateFlag);
	};
	const handleSaveDashboardSettings = newSettings => {
		setState(prevValue => ({
			...prevValue,
			dashBoardSettings: newSettings,
		}));
	};
	return (
		<CategoryInsightsSettingsContext.Provider
			value={{
				...state,
				cardTypes,
				cardsSettings,
				isCardsSettingsSaving,
				refetch: fetchData,
				updateValue,
				handleSaveSettings,
				handleSaveCardSettings,
				handleToggleCard,
				handleCardTypeFilter,
				handleSaveDashboardSettings,
			}}
		>
			{children}
		</CategoryInsightsSettingsContext.Provider>
	);
};

export {
	CategoryInsightsSettingsContextProvider,
	CategoryInsightsSettingsContext,
};
